import { fieldTypes, SectionHeader } from "@ucl/library";
import { FC } from "react";
import { FieldComplexV2 } from "./FieldComplexV2";
import "./ComplexFields.scss";
import { COMPLEX_FIELD_KEYS } from "@/constants/fieldKeys";
import { DepositApplicationReadDTO } from "@/types";

export interface EStatementsOptInComplexValue {
  showHeader?: boolean;
  headerLabel?: string;
  readOnly?: boolean;
}

export interface EStatementsOptInComplexFieldProps extends fieldTypes.BaseFieldProps<any> {
  formValue?: DepositApplicationReadDTO;
}

export const EStatementsOptInComplexField: FC<EStatementsOptInComplexFieldProps> = (props) => {
  const eStatementsOptInComplexValue = props.complexFieldValue as EStatementsOptInComplexValue;
  // E-statements should always be disabled since it defaults to true
  const readOnly = true;

  return (
    <section className="complex-field-container e-statements-opt-in">
      <SectionHeader label={eStatementsOptInComplexValue?.headerLabel || props.label} hidden={!eStatementsOptInComplexValue?.showHeader} />
      <div className="complex-field-content">
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.E_STATEMENTS_OPT_IN.IS_E_STATEMENTS_OPT_IN_ENABLED}
          complexFieldProps={{
            disabled: readOnly,
          }}
        />
        {props.formValue?.eStatementsOptIn?.isEStatementsOptInEnabled && (
          <div className="opt-ins-form-v2__message">
            <div className="opt-ins-form-v2__message-content">
              You are automatically enrolled in eStatements! If you would like to receive paper
              statements, they are available upon request.
            </div>
          </div>
        )}
      </div>
    </section>
  );
};
